import { IonInput, IonItem, IonLabel, IonNote } from '@ionic/react'
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router'
import failedImg from '../../../assets/images/error.svg'
import Button from '../../../components/Button'
import { useAppContext } from '../../../context/AppContext'
import { useStepsContext } from '../../../context/StepsContext'
import useMessages from '../../../hooks/useMessages'
import useRequests from '../../../hooks/useRequests'
import useValidate from '../../../hooks/useValidate'
import { changeEmailContact, procedureComplete } from '../../../redux/actions'
import { formatDate } from '../../../utils/utils'

const DataConfirmation = () => {
  const lineForm = useSelector((state: any) => state.nomLineForm)

  const [emailInput, setEmailInput] = useState(lineForm.emailOptional)
  const {
    newProcedureStep,
    dataStep,
    setNewProcedureStep,
    setDataStep,
    savedDocument,
    setSavedDocument,
    resetSteps
  }: any = useStepsContext()
  const { setBlockNavigation }: any = useAppContext()
  const idForm = useSelector((state: any) => state.idNominativityForm)
  const { saveNominativity } = useRequests('idNominativityForm')
  const [emailError, setEmailError] = useState('')
  const { toastMessage } = useMessages()
  const { validate } = useValidate()
  const dispatch = useDispatch()
  const history = useHistory()

  const nextStepHandler = async (event: any) => {
    const response = await saveNominativity() // Servicio que guarda la Nominatividad
    if (!response?.success) {
      setDataStep(dataStep + 1)
      return setSavedDocument(false)
    }
    toastMessage('Los datos se guardaron con éxito.', 3000, 'bottom', 'success')
    setNewProcedureStep(newProcedureStep + 1)
  }

  const onBack = () => {
    dispatch(procedureComplete())
    resetSteps()
    history.push('/procedures/nominatividad')
    setBlockNavigation(false)
  }

  const handleEmail = (event: any) => {
    const currentValue = event.detail.value
    setEmailError(validate(currentValue, 'emailOptional'))
    dispatch(changeEmailContact({ email: currentValue, label: 'emailOptional', form: 'nomLineForm' }))
    setEmailInput(currentValue)
  }

  return (
    <>
      {dataStep === 1 && (
        <main className="dataConfirmation">
          <div className="dataConfirmation-container">
            <h3 id="ya-casi-estamos">Ya casi estamos</h3>
            <p className="recomendaciones">
              Recordá que al confirmar la <br /> activación de la línea, aceptás <br /> haber tomado los recaudos para{' '}
              <br />
              validar al titular de la misma.
            </p>

            <div className="dataConfirmation-card">
              <b id="data-confirmation-b-datos-titular">Datos del titular de la línea</b>
              <p>
                {idForm?.lastName} {idForm?.names}
              </p>
              <p> {idForm?.passport} </p>
              <p> {idForm?.birthDate && formatDate(idForm?.birthDate)} </p>
              <hr />
            </div>

            <div className="dataConfirmation-input">
              <IonItem shape="round">
                <IonLabel position="floating">Correo electrónico (Opcional)</IonLabel>
                <IonInput
                  id="data-confirmation-ion-input-email"
                  type="email"
                  onIonChange={handleEmail}
                  value={emailInput}
                ></IonInput>
              </IonItem>
              {emailError ? (
                <span className="input-error">{emailError}</span>
              ) : (
                <IonNote className="input-info large-note">
                  Recordale al cliente que puede retirar su documentación en un Centro de Atención de Claro
                </IonNote>
              )}
            </div>
            <Button
              id="data-confirmation-continue"
              className="submit-button btn-margin-down"
              handleSubmit={nextStepHandler}
              label="Continuar"
              validity={!!emailError}
            />
          </div>
        </main>
      )}

      {/* <!-- Error --> */}
      {dataStep === 2 && !savedDocument && (
        <main className="landing">
          <div className="landing-container">
            <img
              id="data-confirmation-failed-img"
              src={failedImg}
              style={{ height: '150px' }}
              alt="something went wrong"
            />
            <h3 id="something-went-wrong">
              <strong>Algo salió mal</strong>
            </h3>

            <p className="error-sugest">
              No pudimos guardar los datos <br />
              correctamente. Por favor intentá nuevamente más tarde.
            </p>

            <Button
              id="back-to-start"
              className="submit-button"
              label="Volver al inicio"
              landing
              handleSubmit={onBack}
            />
          </div>
        </main>
      )}
    </>
  )
}

export default DataConfirmation
